package com.wintermar.inspection.core.ui.component.image.util

enum class FileMimeType(val value: String) {
    PDF("application/pdf"),
    IMAGE("image/jpeg"),
    DOC("application/msword"),
    DOCX("application/vnd.openxmlformats-officedocument.wordprocessingml.document"),
    XLS("application/vnd.ms-excel"),
    XLSX("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

    companion object {
        fun getMimeTypeFromExtension(extension: String): FileMimeType {
            return when (extension) {
                "pdf" -> PDF
                "doc" -> DOC
                "docx" -> DOCX
                "xls" -> XLS
                "xlsx" -> XLSX
                else -> IMAGE
            }
        }
    }
}
